export const INVITES_PER_PAGE = 10;

export enum EBEInviteErrorMessages {
  AlreadySetUp = 'Employee has already set up an account',
  InPending = 'Invitation has already been sent - check the pending list',
  InviteExists = 'Invitation with this email already exists.'
}
